import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '@mui/material/Button';
import useCopyLinkButton from './useCopyLinkButton';

export function CopyLinkButton (props) {
    const {
        inProgress = false,
        onClick = () => {},
        buttonClass = {},
        copyLabel = 'Copy link',
        copiedLabel = 'Link copied!',
    } = props;

    const {
        buttonLabel,
    } = useCopyLinkButton({
        inProgress,
        copyLabel,
        copiedLabel,
    });

    return (
        <Button
            classes={{ root: classNames(["data-ecal-copy-link-button", buttonClass]) }}
            onClick={() => onClick()}
        >
            { buttonLabel }
        </Button>
    );
}

CopyLinkButton.propTypes = {
    inProgress: PropTypes.bool,
    onClick: PropTypes.func,
    buttonClass: PropTypes.any,
    copyLabel: PropTypes.string,
    copiedLabel: PropTypes.string,
};

export default CopyLinkButton;